import { render, staticRenderFns } from "./sdg-goal.vue?vue&type=template&id=7a38bd44&scoped=true"
import script from "./sdg-goal.vue?vue&type=script&lang=js"
export * from "./sdg-goal.vue?vue&type=script&lang=js"
import style0 from "./sdg-goal.vue?vue&type=style&index=0&id=7a38bd44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a38bd44",
  null
  
)

export default component.exports